import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StaticPageLayoutComponent } from '../static-page-layout/static-page-layout.component';
import { AppIconComponent } from '../../shared-components/icon/icon.component';

@Component({
  selector: 'app-privacy-policy',
  standalone: true,
  imports: [CommonModule, StaticPageLayoutComponent, AppIconComponent],
  templateUrl: './privacy-policy.component.html',
  styleUrls: ['./privacy-policy.component.scss']
})
export class PrivacyPolicyComponent {}
